// src="https://d1mluz1pfkw29o.cloudfront.net/pop-up/2025_spring_sales_desktop.jpeg"

import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import axios from "axios";
import yaml from 'js-yaml';
import {PromoConfig} from "../settings";
import {isPromoActive} from "../utils/promoConfig";
import {isPrerenderCapture} from '../utils/prerender';

// const EXPIRATION_DATE = new Date('2025-05-06'); // Spring sales end date

const DEFAULT_PROMO_CONFIG = {
    expire: "2025-05-05T00:00:00Z",
    image_url: "https://d1mluz1pfkw29o.cloudfront.net/pop-up/2025_spring_sales_mobile.jpeg",
    image_url_desktop: "https://d1mluz1pfkw29o.cloudfront.net/pop-up/2025_spring_sales_desktop.jpeg",
    link: "https://vieunite.com/home/digital-canvas?promocode=SAVE20",
};

export default function ImagePrompt({ isMobile }) {
    const [visible, setVisible] = useState(true);
    const [promoConfig, setPromoConfig] = useState(DEFAULT_PROMO_CONFIG);

    useEffect(() => {
        if (isPrerenderCapture()) return;
        // Fetch expiration date from server
        const fetchExpirationDate = async () => {
            try {
                const response = await axios.get(PromoConfig, {
                    headers: {
                        'Cache-Control': 'no-cache',
                        'Pragma': 'no-cache'
                    }
                });
                const yml = yaml.load(response.data) || {};
                const nextPromoConfig = {...DEFAULT_PROMO_CONFIG, ...yml};
                console.log("reading date https://vieunite.com/promo_expiration.txt");
                console.log(response);
                console.log("promo active: " + isPromoActive(nextPromoConfig) + " " + response.data);
                if (response?.data) {
                    setPromoConfig(nextPromoConfig);
                }
            } catch (error) {
                console.error('Failed to fetch expiration date:', error);
                // Fallback to a default date or handle error appropriately
            }
        };
        fetchExpirationDate();
    }, []);


    useEffect(() => {
        if (isPrerenderCapture()) return;
        if (visible && isPromoActive(promoConfig)) {
            document.body.style.overflowY = 'hidden';
            document.body.style.overflowX = 'hidden';
        } else {
            document.body.style.overflowY = '';
        }

        return () => {
            document.body.style.overflowY = '';
        };
    }, [visible, promoConfig]);

    if (isPrerenderCapture() || !visible || !isPromoActive(promoConfig)) return null;

    return createPortal(
        <div style={overlayStyle}>
            <div style={modalStyle}>
                <button style={closeButtonStyle} onClick={() => setVisible(false)}>
                    &times;
                </button>
                <img
                    // src={isMobile ? "https://d1mluz1pfkw29o.cloudfront.net/pop-up/2025_spring_sales_mobile.jpeg" : "https://d1mluz1pfkw29o.cloudfront.net/pop-up/2025_spring_sales_desktop.jpeg"}
                    src = {isMobile ? promoConfig.image_url : promoConfig.image_url_desktop}
                    alt="Prompt"
                    style={{ width: '100%', borderRadius: '12px', cursor: 'pointer' }}
                    onClick={() => {
                        // window.location.href = `${window.location.origin}/home/digital-canvas?promocode=SAVE200`;
                        window.location.href = promoConfig.link;
                        setVisible(false);
                    }}
                />
            </div>
        </div>,
        document.body
    );
}

const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
};

const modalStyle = {
    backgroundColor: 'white',
    // padding: '20px',
    borderRadius: '12px',
    maxWidth: '90%',
    maxHeight: '90%',
    position: 'relative',
    boxShadow: '0 0 20px rgba(0,0,0,0.3)',
};

const closeButtonStyle = {
    position: 'absolute',
    top: '12px',
    right: '12px',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    backgroundColor: 'white',
    border: '1px solid #ccc',
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#333',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
};
